import { DashboardLayout } from "@/components";
import { stAdminMiddleware } from "@/middleware";
import { STAdminUsers } from "@/pages/st-admin";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/st-admin/users/")({
	component: () => (
		<DashboardLayout>
			<STAdminUsers />
		</DashboardLayout>
	),
	loader: stAdminMiddleware,
});
